// removed by extract-text-webpack-plugin
module.exports = {"container":"_2QzY8TGFAv9wCaguXTkrw8","barLeft":"_3d-w9lZD8tbsz3rHWXZCyi","iconTop":"keg_eiSFf13lEfUMm7gyN","textV":"_14RSwYK8844o8xjWYkgaK2","actionIcon":"_3bWYao5XKloCNLpjROlPKK","content":"_2JMHZGT36W-H2R9uzoEdBh","date":"_1QGYXY8Wi2XyyKzBLN7HW9","title":"_2Lv-2bR30oD5RLETK7EVxu","location":"_2Qw6_VAxJesGGyN2t2RzrK","city":"_2BaxgcpQ1WQUwPAu2KNSw5","body":"_314A6F9HaTd5dYqPWPDCr6","spam":"pIleFB5lpLNO1SRQVCmZF","item":"_2z1hjuQsApsRjRLwSNa9dp","listMembers":"_1Ri5vRAU1m4-zfFMWO12yG","hr":"_1vTP1bVFBffK5QbKTRfdf5"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/BoxInscription/style.css
// module id = 497
// module chunks = 38